import React, { Component } from 'react';
import { Modal, Table, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class AssociatedEvaluationRecord extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
        selectedRowKeys: [],
        topTitleData: {},
    }

    show = (record = {}) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            record: {},
            visible: false,
            loading: false,
            selectedRowKeys: [],
        });
    }

    loadData = () => {
        const {record: { evaluateRecordId }} = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryListForAssociation,
            data: { evaluateRecordId },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    topTitleData: res.data,
                    data: res.datas,
                    loading: false,
                })
            }
        };
        $.sendRequest(options);
    }

    submit = () => {
        const { selectedRowKeys, record: { evaluateRecordId } } = this.state;
        Modal.confirm({
            title: <div style={{ marginLeft: 42 }}>确认进行临床评估关联吗?</div>,
            content: '一旦发生关联，临床PM参照临床方案预测项目参数、项目方案/FTE报价规划以及重点难点分析&其他备注说明的数据将被全量覆盖【项目基本信息、项目服务内容、客户项目参数内容不做关联】',
            onOk: () => {
                this.setState({ loading: true });
                const options = {
                    method: 'POST',
                    url: API_URL.evaluate.associateEvaluate,
                    data: { 
                        targetId: evaluateRecordId,
                        sourceId: selectedRowKeys[0],
                    },
                    dataType: 'json',
                    doneResult: res => {
                        message.success(res.success);
                        this.hide();
                        this.props.loadData();
                    }
                };
                $.sendRequest(options);
            },
        });
        
    }

    showViewPage = (record) => {
        const { evaluateRecordId, evaluateCode, quotationType } = record;
        sessionStorage.evaluateRecordId = evaluateRecordId;
        sessionStorage.evaluateCode = evaluateCode;
        sessionStorage.quotationType = quotationType;
        window.open(`./#/clinicalEvaluation/ViewPage`);
    }

    getColumns = () => [{
        title: '临床评估单号',
        dataIndex: 'evaluateCode',
        key: 'evaluateCode',
        width: 160,
        render: (text, record) => <a onClick={ () => this.showViewPage(record)}>{text}</a>
    }, {
        title: '方案编号',
        dataIndex: 'evaluateSerialNumber',
        key: 'evaluateSerialNumber',
        width: 100,
    }, {
        title: '申办方',
        dataIndex: 'sponsorName',
        key: 'sponsorName',
        width: 120,
    }, {
        title: '合同签署方',
        dataIndex: 'contractSignName',
        key: 'contractSignName',
        width: 120,
    }, {
        title: '临床分期',
        dataIndex: 'investigationByStageNames',
        key: 'investigationByStageNames',
        width: 120,
    }]

    onSelectChange = (record, selected) => {
        const { evaluateRecordId } = record;
        let list = [];
        if (selected) {
            list.push(evaluateRecordId);
        } else {
            list = list.filter(el => el != evaluateRecordId);
        }
        this.setState({ selectedRowKeys: list });
    }

    render() {
        const { visible, loading, data, selectedRowKeys, topTitleData } = this.state;
        const { 
            evaluateCode,
            contractSignName,
            lineOfBusinessString,
            diseaseName,
            investigationAreaName,
            researchProductTypeName,
        } = topTitleData;
        const rowSelection = {
            type: 'radio',
            selectedRowKeys,
            onSelect: this.onSelectChange,
        };
        return (
            <Modal
                title="关联已有评估记录"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="preview-modal"
                maskClosable={false}
                confirmLoading={loading}
                width="1000px"
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        临床评估单号：{evaluateCode}
                        <span className="ant-divider" />
                        合同签署方：{contractSignName}
                        <span className="ant-divider" />
                        业务线：{lineOfBusinessString}
                        <span className="ant-divider" />
                        适应症：{diseaseName}
                        <span className="ant-divider" />
                        治疗领域：{investigationAreaName}
                        <span className="ant-divider" />
                        研究产品类型：{researchProductTypeName}
                    </div>
                    <div>
                        <Table
                            rowSelection={rowSelection}
                            rowKey={record => record.evaluateRecordId}
                            dataSource={data}
                            loading={loading}
                            columns={this.getColumns()}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default AssociatedEvaluationRecord


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/AssociatedEvaluationRecord.js